import { cn } from "~/utils/shadecn"

// SFW visibility policy
// ---------------------
// Two-tier gate:
//   1. SFW content is visible to all users, including anonymous visitors.
//   2. Must be payment-verified (age-verified) to see NSFW content.
//
// Network-level privacy: handled by `gateStillsToUser` in
// app/models/videos.server.ts — non-payment-verified users (anonymous or logged-in)
// receive only SFW-tagged stills.
//
// Visual blur strategy:
//   - Avatars: CSS blur-2xl only.
//   - Video stills (VideoCard): pre-blurred BlurredStill + CSS blur-2xl layered on top.
//     See workers.server.ts for server-side blur details.

export function shouldBlurAvatar(isPaymentVerified?: boolean, isSFW?: boolean) {
  return !isSFW && !isPaymentVerified
}

export function avatarImageClassName(isPaymentVerified?: boolean, isSFW?: boolean, baseClassName = "object-cover") {
  return cn(baseClassName, shouldBlurAvatar(isPaymentVerified, isSFW) && "blur-2xl")
}

export function shouldUseBlurredStill(isPaymentVerified?: boolean, sfwStills?: boolean) {
  return !sfwStills && !isPaymentVerified
}
